import { useTranslate } from '@festina-life/ui/hooks'
import { useMemo } from 'react'

import { CcCalcStepFieldName } from './ccCalcStep/CcCalcStepFieldName'
import { CcCalcStepFieldType } from './ccCalcStep/CcCalcStepFieldType'
import { CcCalcStepFieldValue } from './ccCalcStep/CcCalcStepFieldValue'
import { getCalcStepPriority } from './ccCalcStep/helpers'
import type {
  SpecialCasedSubTemplatedValueSetup,
  SpecialCaseFieldComponentsConfiguration,
} from './types'

export const useSpecialSubTemplatedTemplatedConfigurations = () => {
  const translate = useTranslate()

  return useMemo(
    () =>
      ({
        CcCalcStep: {
          components: [
            CcCalcStepFieldName,
            CcCalcStepFieldType,
            CcCalcStepFieldValue,
          ],
          sort: (
            a: SpecialCasedSubTemplatedValueSetup,
            b: SpecialCasedSubTemplatedValueSetup,
          ) => getCalcStepPriority(a) - getCalcStepPriority(b),
          variableWidthTableColumns: [
            { title: translate('templateViewer.header.type'), ratio: 1 },
            { title: translate('templateViewer.header.value'), ratio: 4 },
          ],
        },
      }) as Record<string, SpecialCaseFieldComponentsConfiguration>,
    [translate],
  )
}
